// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__37aLN","title":"Info_title__1uyKY","selects":"Info_selects__1mmsP","requiredAsterisk":"Info_requiredAsterisk__3rSse"};